export const GET_COURSE_VIDEO_START = 'GET_COURSE_VIDEO_START';
export const GET_COURSE_VIDEO_FAIL = 'GET_COURSE_VIDEO_FAIL';
export const GET_COURSE_VIDEO_SUCCESS = 'GET_COURSE_VIDEO_SUCCESS';
